import { z } from 'zod';
import { DatiqGeoSuggestionSchema } from '../../../models';

export const DatiqCellLaneSchema = z.object({
    id: z.string().optional(),
    origin: DatiqGeoSuggestionSchema,
    destination: DatiqGeoSuggestionSchema,
});

export interface IDatiqCellLane extends z.infer<typeof DatiqCellLaneSchema> {}
